<!-- 由 suu 创建于 2022-01-07 星期五 -->
<template>
  <div class="ItemMeal">
    <!-- 日期选择 -->
    <div class="im-date" @click="showDate = true">
      选择日期 <span>{{ curDateText }}</span> <span class="d-icon"></span>
    </div>
    <!-- 打卡人数 -->
    <div class="im-clocks">
      <div class="c-left">
        <div class="l-top">{{ info.clockNums }}<span>人</span></div>
        <div class="l-bot">打卡人数</div>
      </div>
      <div class="c-line"></div>
      <div class="c-right">
        <div class="r-text">营期总人数：{{ info.campNums }}</div>
        <div class="r-text r-text-bot">参与度：{{ info.clockRate }}</div>
      </div>
    </div>
    <!-- 三餐打卡进度 -->
    <div class="im-title">三餐打卡进度（单位/人）</div>
    <item-meal-card
      type="clock"
      :cardArr="clockArr"
      :info="info"
    ></item-meal-card>
    <!-- 三餐点评进度 -->
    <div class="im-title">三餐点评进度（单位/人）</div>
    <item-meal-card
      type="comment"
      :cardArr="commentArr"
      :info="info"
    ></item-meal-card>
    <!-- 异常名单 -->
    <div class="im-title">异常名单</div>
    <item-meal-abnormal :info="info.abnormal"></item-meal-abnormal>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="handelDateChange"
        @cancel="showDate = false"
      />
    </van-popup>
  </div>
</template>

<script>
import DATE from '@/common/date.js'
import ItemMealCard from './ItemMealCard.vue'
import ItemMealAbnormal from './ItemMealAbnormal.vue'
export default {
  name: 'ItemMeal',

  components: { ItemMealCard, ItemMealAbnormal },

  props: {
    info: {},
    starDay: {},
    endDay: {},
    initDay: {}
  },

  data() {
    return {
      showDate: false,
      currentDate: new Date(),
      clockArr: [
        {
          title: '早餐卡',
          key: 'breakfast',
          sub: '当前进度',
          sub2: '建议进度'
        },
        {
          title: '午餐卡',
          key: 'lunch',
          sub: '当前进度',
          sub2: '建议进度'
        },
        {
          title: '晚餐卡',
          key: 'dinner',
          sub: '当前进度',
          sub2: '建议进度'
        },
        {
          title: '加餐卡',
          key: 'add',
          sub: '',
          sub2: ''
        }
      ],
      commentArr: [
        {
          title: '早餐卡',
          key: 'breakfast',
          sub: '超时点评',
          sub2: '平均用时'
        },
        {
          title: '午餐卡',
          key: 'lunch',
          sub: '超时点评',
          sub2: '平均用时'
        },
        {
          title: '晚餐卡',
          key: 'dinner',
          sub: '超时点评',
          sub2: '平均用时'
        },
        {
          title: '加餐卡',
          key: 'add',
          sub: '',
          sub2: ''
        }
      ]
    }
  },

  computed: {
    minDate() {
      return new Date(this.starDay.replace(/-/g, '/'))
    },
    maxDate() {
      return new Date(this.endDay.replace(/-/g, '/'))
    },
    curDateText() {
      return DATE.formatDate(this.currentDate, '.')
    }
  },

  watch: {},

  created() {
    this.currentDate = this.initDay
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 日期改变
     */
    handelDateChange(date) {
      this.showDate = false
      this.$emit('date-change', date)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ItemMeal {
  width: 100%;
  box-sizing: border-box;
  .im-date {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    position: relative;
    height: 37px;
    background: #f7f7f7;
    border-radius: 4px;
    border: 1px solid #f1f1f1;
    font-size: 13px;
    color: #7b7b7b;
    padding: 0 12px;
    line-height: 18px;
    span {
      flex: 1;
      font-size: 13px;
      margin-left: 10px;
      color: #000;
      font-weight: 500;
    }
    span.d-icon {
      position: absolute;
      top: 50%;
      right: 12px;
      margin-top: -1.6vw;
      border: 4px solid;
      border-color: transparent transparent #bbbbbb #bbbbbb;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      opacity: 0.8;
      content: '';
    }
  }
  .im-clocks {
    width: 100%;
    box-sizing: border-box;
    background: rgba($color: #eaf3ff, $alpha: 0.7);
    border-radius: 6px;
    border: 1px solid #deebfe;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    .c-left {
      flex: 1;
      .l-top {
        font-size: 26px;
        font-weight: 500;
        color: #3b4761;
        span {
          font-size: 19px;
        }
      }
      .l-bot {
        font-size: 12px;
      }
    }
    .c-right {
      flex: 1;
      font-size: 12px;
      .r-text-bot {
        margin-top: 5px;
      }
    }
    .c-line {
      width: 1px;
      height: 39px;
      background-color: #e7e7e7;
      margin: 0 20px;
    }
  }
  .im-title {
    font-size: 13px;
    font-weight: 500;
    margin-top: 16px;
    color: #000000;
  }
}
</style>
